import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { convertWorkflowToFlowFormat } from '@/lib/workflowUtils';

const initialState = {
  workflowList: {},
  workflowListLoading: false,

  workflowHistoryList: {},
  workflowHistoryListLoading: false,

  // Temporary workflow building state
  tempNodes: [],
  tempEdges: [],
  tempTrigger: [],

  // Workflow metadata
  workflowName: '',
  workflowDescription: '',
  channels: [],

  // Workflow settings
  isActive: false,
  reEnrollment: false,
  enrollExisting: false,
  removeIfIneligible: true,
  workflowFirstActivatedAt: null,
};

const useWorkflowStore = create(
  devtools(
    (set) => ({
      ...initialState,
      setWorkflowList: (workflowList) => set({ workflowList }),
      setWorkflowListLoading: (workflowListLoading) =>
        set({ workflowListLoading }),

      setWorkflowHistoryList: (workflowHistoryList) =>
        set({ workflowHistoryList }),
      setWorkflowHistoryListLoading: (workflowHistoryListLoading) =>
        set({ workflowHistoryListLoading }),

      // Temporary workflow state setters
      setTempNodes: (tempNodes) => set({ tempNodes }),
      setTempEdges: (tempEdges) => set({ tempEdges }),
      setTempTrigger: (tempTrigger) => set({ tempTrigger }),

      // Workflow metadata setters
      setWorkflowName: (workflowName) => set({ workflowName }),
      setWorkflowDescription: (workflowDescription) =>
        set({ workflowDescription }),
      setChannels: (channels) => set({ channels }),

      // Workflow settings setters
      setIsActive: (isActive) => set({ isActive }),
      setReEnrollment: (reEnrollment) => set({ reEnrollment }),
      setEnrollExisting: (enrollExisting) => set({ enrollExisting }),
      setRemoveIfIneligible: (removeIfIneligible) =>
        set({ removeIfIneligible }),

      removeWorkflowFromList: (workflowId) =>
        set((state) => ({
          workflowList: {
            ...state.workflowList,
            data: state.workflowList.data.filter(
              (workflow) => workflow._id !== workflowId
            ),
          },
        })),

      setWorkflowForEditing: (workflowData) => {
        if (workflowData) {
          const { nodes, edges } = convertWorkflowToFlowFormat(workflowData);
          console.log(
            'Setting workflow data in store:',
            workflowData,
            nodes,
            edges
          );
          set({
            tempNodes: nodes,
            tempEdges: edges,
            tempTrigger: workflowData.triggers || [],
            workflowName: workflowData.name || '',
            workflowDescription: workflowData.description || '',
            channels: workflowData.channel || [],
            isActive: workflowData.is_active || false,
            reEnrollment: workflowData.re_enrollment || false,
            enrollExisting: workflowData.enroll_existing || false,
            removeIfIneligible:
              workflowData.remove_if_ineligible !== undefined
                ? workflowData.remove_if_ineligible
                : true,
            workflowFirstActivatedAt:
              workflowData.workflow_first_activated_at || null,
          });
        } else {
          console.error('setWorkflowForEditing called with invalid data');
        }
      },
      resetTempWorkflowState: () => {
        set({
          tempNodes: [],
          tempEdges: [],
          tempTrigger: [],
          workflowName: '',
          workflowDescription: '',
          channels: [],
          isActive: false,
          reEnrollment: false,
          enrollExisting: false,
          removeIfIneligible: true,
        });
      },
    }),
    { name: 'workflowStore' }
  )
);

export default useWorkflowStore;
